import { AbyssTheme as themeConfiguration } from '@src/app/browser';
import fields from '@src/entities/Criteria/ui/components/Filters/components/Table/includes/fields.json';
import { useCommonCriteria } from '@src/entities/Criteria/ui/hooks/useCommonCriteria';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Badge } from '@uhg-abyss/web/ui/Badge';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Text } from '@uhg-abyss/web/ui/Text';
import { Tooltip } from '@uhg-abyss/web/ui/Tooltip';
import { isArray, isEmpty, isUndefined } from 'lodash';
import React, { useEffect } from 'react';

import { AdditionalCriteriaTooltip, CommonCriteriaTooltip } from './components/tooltips';
import { Styles } from './includes/styles';

/**
 * AppliedFilterCriteria
 *
 * Shows the currently applied filters.
 *
 * @param criteria
 * @param filters
 * @param label
 * @param showLabel
 * @returns {Element}
 * @constructor
 */
export function AppliedFilterCriteria({
  criteria = {
    entrance: {
      commonIds: [],
    },
  },
  filters = [],
  label = '',
  showLabel = true,
}) {
  const { criteriaList, data, fetch, namesList } = useCommonCriteria();

  useEffect(() => {
    if (isEmpty(data) && !isUndefined(criteria?.entrance?.commonIds) && !isEmpty(criteria?.entrance?.commonIds)) {
      fetch(criteria);
    }
  }, [criteria, data]);

  /**
   * getLabel
   *
   * @TODO Needs description.
   *
   * @param theCondition
   * @returns {*}
   */
  const getLabel = (theCondition) => {
    const matchedCondition = fields?.condition?.options?.find((condition) => {
      return condition?.value === theCondition;
    });
    return matchedCondition?.label;
  };

  /**
   * theFilter
   *
   * @TODO Needs description.
   *
   * @param theFilter
   * @returns {*}
   */
  const getFilter = (theFilter) => {
    const matchedFilter = fields?.column?.options?.find((filter) => {
      return filter?.value === theFilter;
    });
    return matchedFilter?.label;
  };

  /**
   * getValue
   *
   * @TODO Needs description.
   *
   * @param theValue
   * @returns {*}
   */
  const getValue = (theValue) => {
    let value = theValue;

    if (isArray(theValue)) {
      value = theValue.join(', ');
    }

    return value;
  };

  return (
    <ErrorHandler location="src/entities/Criteria/ui/components/AppliedFilterCriteria/AppliedFilterCriteria.jsx">
      <Styles>
        <Layout.Group css={{ margin: 0 }}>
          {showLabel === true && !isEmpty(label) && <Text fontWeight="bold">{label}:</Text>}

          {label === 'Common Criteria' ? (
            <Badge
              css={{
                '.abyss-badge-content': { fontWeight: 'normal' },
                '.abyss-icon': {
                  fontSize: 'inherit',
                  fontWeight: 'bold',
                  lineHeight: 'inherit',
                },
              }}
              rounded
              variant="neutral"
            >
              <Layout.Group space={6}>
                <div>
                  <IconSymbol icon="settings" variant="outlined" />
                </div>
                <div>
                  <Tooltip
                    align="start"
                    asChild={false}
                    content={
                      <CommonCriteriaTooltip
                        filters={criteriaList}
                        getFilter={getFilter}
                        getLabel={getLabel}
                        getValue={getValue}
                      />
                    }
                    position="bottom"
                    positionOffset={Number(themeConfiguration?.theme?.space?.md.replace('px', ''))}
                  >
                    <Layout.Group space={6}>{namesList?.join(', \n')}</Layout.Group>
                  </Tooltip>
                </div>
              </Layout.Group>
            </Badge>
          ) : (
            <React.Fragment>
              {filters?.map((filter) => {
                return (
                  <Badge
                    css={{
                      '.abyss-badge-content': { fontWeight: 'normal' },
                      '.abyss-icon': {
                        fontSize: 'inherit',
                        fontWeight: 'bold',
                        lineHeight: 'inherit',
                      },
                    }}
                    key={filter?.column}
                    rounded
                    variant="neutral"
                  >
                    <Layout.Group space={6}>
                      <div>
                        {filter?.column === 'TAGS' && <IconSymbol icon="label" variant="filled" />}
                        {filter?.column.toLowerCase().includes('date') && (
                          <IconSymbol icon="calendar_month" variant="outlined" />
                        )}
                        {filter?.column.toLowerCase().includes('count') && (
                          <IconSymbol icon="numbers" variant="outlined" />
                        )}
                        {filter?.column === 'ACTION_STATUS' && <IconSymbol icon="help_outline" variant="outlined" />}
                        {filter?.column === 'ACTION_PATH_ID' && (
                          <IconSymbol icon="create_new_folder" variant="outlined" />
                        )}
                      </div>
                      <div>
                        <Tooltip
                          align="start"
                          asChild={false}
                          content={
                            <AdditionalCriteriaTooltip
                              filter={filter}
                              getFilter={getFilter}
                              getLabel={getLabel}
                              getValue={getValue}
                            />
                          }
                          position="bottom"
                          positionOffset={Number(themeConfiguration?.theme?.space?.md.replace('px', ''))}
                        >
                          <Layout.Group css={{ maxWidth: '200px', overflow: 'hidden' }} space={6}>
                            <div>{getFilter(filter?.column)}:</div>
                            {getLabel(filter?.condition)}
                            <div>&quot;{getValue(filter?.value)}&quot;</div>
                          </Layout.Group>
                        </Tooltip>
                      </div>
                    </Layout.Group>
                  </Badge>
                );
              })}
            </React.Fragment>
          )}
        </Layout.Group>
      </Styles>
    </ErrorHandler>
  );
}
